import { call, put } from "redux-saga/effects";
import { AxiosError, AxiosResponse } from "axios";

// Response / Request
import { Result } from "@models/common/resultResponse";
import { KeyValue } from "@/main/models/common";

// Redux
import { saveInsuranceSublines, GetInsuranceSublines } from "./index";

// Api's
import { insuranceSublineApi } from "../../api";
import { errorBoundaryReduxSaga, renderErrorReduxSaga } from "@/main/services/utils";

export function* getInsuranceSublinesSaga(action: GetInsuranceSublines) {
	try {
		const response: AxiosResponse<Result<KeyValue[]>> = yield call(insuranceSublineApi.getDomain);
		if (response.data.result) {
			yield put(saveInsuranceSublines(response.data.result, false, null, action.payload.keyReducer));
		}
	} catch (exception) {
		if (exception instanceof AxiosError) {
			const resultError = errorBoundaryReduxSaga(exception);
			renderErrorReduxSaga(resultError);

			yield put(saveInsuranceSublines(null, true, resultError.messagesDataError, action.payload.keyReducer));
		}
	}
}
